virtual = {
    // Funkcia nastavuje button play pri VG
    virtualButton: function(leagueCupID, actualGamePartID, liveBettingView, sideBet, stream, channelID, score) {
        try {
            var button = "";
            if (channelID === "") channelID = null;
            if (["ended"].includes(actualGamePartID)) button += " ui-disabled";
            if (!score && (!["ended", "notstarted", "nonstarted"].includes(actualGamePartID) || liveBettingView == -1)) {
                button += " virtual-game-play";
                if (!channelID && offer.vgL.oneVideo.includes(leagueCupID) && !offer.vgL.krnSoccerOne.includes(leagueCupID)) {
                    // Ak sa jedna o virtualne hry v ktorych sa hra v jednom case len jeden zapas
                    if (stream) {
                        button += " virtual-game-playing";
                    } else {
                        button += " hide-element";
                    }
                } else if ((!channelID || channelID == stored.topScreenVgChannel) && (!stored.topScreenVgVirtualLeague || stored.topScreenVgVirtualLeague == leagueCupID)) {
                    if (!stored.topScreenVgVirtualLeague) {
                        stored.topScreenVgVirtualLeague = leagueCupID;
                    }
                    button += " virtual-game-playing";
                }
                if (offer.vgL.uofTennis.includes(leagueCupID) && sideBet) {
                    button += " btn-side-bet";
                }
            } else if (sideBet) {
                button += " btn-side-bet";
            }
            return button;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            button = " ui-disabled";
            return button;
        }
    },

    // Funkcia vytvara img element/y s obrazkom competitora/ obrazkami competitora pre BetX/Kiron Virtualne hry
    assignCompetitorImage: function(competitorNumber, provider, leagueCupID) {
        try {
            var compImages = "";
            if (competitorNumber.includes("#")) {
                // Vitaz, napr. #1
                competitorNumber = [competitorNumber.replace(/\#/g,'').toString()];
            } else if ((competitorNumber.length > 2) && competitorNumber.includes('-')) {
                // Viaceri competitory napr. 1-2
                competitorNumber = competitorNumber.split('-');
            } else {
                // Ostatne, napr. 1
                competitorNumber = [competitorNumber.toString()];
            }

            competitorNumber.forEach(function(cNumber) {
                compImages += "<img src='/stylesheets/images/" + provider.toLowerCase() + "/" + leagueCupID + "/competitor-" + cNumber + ".png' class='competitor-image'>";
            });

            return compImages;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na renderovanie virtualnych hier
    virtualGamesRender: function(data) {
        try {
            if (data && data[0] && data[0].EventCount && !data.ErrorType) {
                $(".content-offer").addClass("ui-disabled");
                $("#sportsBook, #sportsBookVG, #sportsBookLG").empty().hide();
                // Render
                var leagues = [];
                // Vyfiltruje len regiony (virtualne sporty)
                var regions = data.filter(function(VS) {
                    if (VS.Typ === "LC" && profile.VirtualsProviders.includes(VS.Provider) && !profile.VirtualGameLeaguesDisabled.includes(String(VS.ID))) {
                        leagues.push(VS);
                    } else if (VS.Typ === "RE") {
                        return VS;
                    }
                });
                // Sortovanie samotnych lig
                leagues.sort(function(lA, lB) {
                    return lA.Order - lB.Order;
                });
                regions = regions.map(function(region) {
                    region.leaguesCount = 0;
                    region.leagues = [];
                    region.providers = new Object();
                    leagues.forEach(function(league) {
                        if (region.ID === league.ParentID) {
                            if (!region.providers[league.Provider]) {
                                region.providers[league.Provider] = new Object({
                                    Name: league.Provider,
                                    leagues: []
                                });
                            }
                            region.leagues.push(league);
                            region.providers[league.Provider].leagues.push(league);
                            region.leaguesCount = ++region.leaguesCount;
                        }
                    });
                    return region;
                }).filter(function(region) {
                    if (region.providers && !$.isEmptyObject(region.providers)) return region;
                });

                // Render
                if (profile.VirtualsStructureProviders) {
                    // Renderovanie virtualnych hier pomocou pomocou purejs s pouzitim jquery mobile
                    $p("#sportsBookVG").render(regions, T.sportsBookVG);
                    $("#sportsBookVG").trigger("create");
                    regions.forEach(function(region) {
                        if (profile.VirtualsStructure || region.leaguesCount > 1) {
                            $("#sportsBookVG #RE" + region.ID).find('.ui-collapsible-content>.ui-collapsible-content').removeClass();
                        }
                    });
                    // Zobrazenie v poradi 1. Virtualnej hry
                    $("#sportsBookVG .virtual-sport").first().trigger("expand");
                    // Scroll buttonov
                    $("#sportBox .ui-content #offerBottom .arrows").removeAttr("style");
                    setTimeout(function() {
                        shared.scrollModule.scrollButtons("offerVG");
                    });
                } else {
                    // Renderovanie virtualnych hier pomocou pomocou purejs s pouzitim raw html & css
                    $p("#sportsBookVG").render(regions, T.sportsBookVGNoProviders);
                    // Simulaciou kliknutia na prvy virtualny sport dojde k jeho otvoreniu
                    $("#sportsBookVG .virtual-sport").first().trigger("click");
                }
                // Zobrazenie tlacidiel hlasitosti
                if (profile.HaveSound) $("#setVolumeToggle").show();
                // Zobrazenie ponuky VG
                $("#sportsBookVG").removeClass("ui-disabled").show();
                $("#events").removeClass().show();
                $("#home, #empty").hide();
                $(".content-offer, #sportsBookVG").removeClass("ui-disabled");
                return true;
            } else {
                $("#events #noEvents h1").html(texts.NoEventsHeader);
                $("#events #noEvents .message").html(texts.NoEventsMessage);
                $("#events #noEvents #redirectButton .ui-btn-text").text(texts.FooterLabelOffer).show();
                $("#events #noEvents").addClass("not-available");
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            $(".content-offer").removeClass("ui-disabled");
            modal.showErrObj(1, 5, {err1: texts.ConnectionErr, errType: "ConnectionErr"});
            main.setPage(1);
            return false;
        }
    },

    // Funkcia na zobrazenie virtualnej ligy
    virtualLeagues: function(VSID, VLID, provider) {
        try {
            if (VSID && VLID) {
                $(".content-offer, #sportsBookVG, #events").addClass("ui-disabled");
                shared.scrollModule.scrollButtons("offerVG");
                // Zrusenie inline detailu zapasu
                if (offer.eventID) main.closeDialog();
                // Zobrazi video na hornej obrazovke
                if (offer.vgL.evona.includes(VLID)) {
                    stored.topScreenActive = "virtualsEvona";
                } else {
                    stored.topScreenActive = "virtuals";
                }
                stored.topScreenVgVirtualLeague = VLID;
                stored.topScreenVgChannel = 0;
                communication.topScreen(stored.topScreenActive, {
                    screenShow: true,
                    gameID: VSID,
                    leagueID: stored.topScreenVgVirtualLeague,
                    channelID: stored.topScreenVgChannel
                });
                if (profile.VirtualsStructureProviders) {
                    // Oznaci button zvoleneho virtualneho sportu
                    $("#sportsBookVG .vg-providers").removeClass("virtual-league-active");
                    $("#sportsBookVG .provider-content").removeClass("virtual-league-active");

                    $("#sportsBookVG #RE" + VSID + " .provider-content#LC" + VLID).addClass("virtual-league-active");
                    $("#tableTop .table-title").text($("#sportsBookVG #RE" + VSID + " .vg-sport-title").text());
                    if (profile.FlatCSS) {
                        $("#tableTop .table-icon").removeClass().addClass("table-icon");
                        $("#tableTop .table-icon").addClass("sport-color-153 sport-icon-153-region-" + VSID);
                    }
                } else {
                    // Oznaci button zvoleneho virtualneho sportu
                    $("#sportsBookVG .virtual-sport__league-button").removeClass("virtual-sport__league-button--active")
                    .filter("#LC" + VLID).addClass("virtual-sport__league-button--active");
                }

                // Render ponuky
                offer.sportID = offer.vgID;
                offer.provider = provider;
                offer.regionID = VSID;
                offer.leagueCupID = VLID;
                service.loadPure('sportsBookEvents');

                // Otvori inline detail vybranych lig
                setTimeout(function() {
                    shared.scrollModule.scrollReload("sportsBookEvents", "reload");
                    if ([602578, 602577].includes(VLID)) {
                        $('#section fieldset:not(.event-suspended):first').find('.ui-block-5 a').click();
                    }
                }, 500);
                return true;
            } else {
                return false;
            }
        } catch (e) {
            $(".content-offer, #sportsBookVG, #events").removeClass("ui-disabled");
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na rozbalenie virtualnych lig po kliknuti na virtualny sport
    virtualLeaguesExpand: function(region) {
        // Zatvori vsetky virtualne sporty
        $("#sportsBookVG .virtual-sport").not($("#sportsBookVG #RE" + region)).removeAttr("open");

        // Vynuti otvorenie 1. ligy v danom virtualnom sporte po kliknuti na virtualny sport
        if (!$("#sportsBookVG #RE" + region).attr("open")) {
            // Nastavenim bubbles na false zabraniem, aby sa kliknutie na virtualny sport propagovalo do parenta .virtual-sport
            $("#sportsBookVG #RE" + region + " .virtual-sport__league-button").first()[0].dispatchEvent(
                new MouseEvent('mousedown', { bubbles: false })
            );
        }

        // Po prvotnom otvoreny sekcie virtualnych hier otvori collapsible
        setTimeout(function() {
            $("#sportsBookVG #RE" + region).attr("open", true);
            // Scroll buttonov
            shared.scrollModule.scrollButtons("offerVG");
        }, 0, region);
    }
};

// Odchytenie rozbalenia PRVEJ urovne VG SPORT
$("#sportsBookVG .SB-level-root").live("expand", function (e) {
    if (region = $(this).attr("id")) {
        shared.scrollModule.scrollReload("sportsBookEvents", "clear");
        stored.allEvents = null;
        communication.dataTrackModule.setScreenPath(0, $(e.target).find(".vg-sport-title").text()); // GA4 - zaznamenanie cesty pre zmenu title pre trackovanie GA eventov podla title
        // Zatvori rozbalene sporty
        $("#sportsBookVG .virtual-sport").not(this).trigger("collapse");
        // Otvori 1. providera daneho sportu
        $(this).find('.vg-providers').first().trigger("expand");
        $("#sportsBookVG #" + region).addClass("virtual-sport-active");
        return false;
    }
});

// Odchytenie zbalenia PRVEJ urovne VG SPORT
$("#sportsBookVG .SB-level-root").live("collapse", function () {
    // Odznaci zvyraznenie virtualnych sportov
    $("#sportsBookVG .virtual-sport").removeClass("virtual-sport-active");
    // Zobrazenie tlacitok na scrollovanie
    shared.scrollModule.scrollButtons("offerVG");
    return false;
});

// Odchytenie rozbalenia DRUHEJ urovne VG PROVIDER
$("#sportsBookVG .SB-level-a").live("expand", function (e) {
    shared.scrollModule.scrollReload("sportsBookEvents", "clear");
    stored.allEvents = null;
    // Zatvori rozbalenych providerov
    $("#sportsBookVG .vg-providers").not(this).trigger("collapse");
    // Rozkliknutie 1. ligy providera
    $(this).find('.provider-content').first().mousedown();
    communication.dataTrackModule.setScreenPath(1, $(e.target).find(".provider-name-label").text());  // GA4 - zaznamenanie cesty pre zmenu title pre trackovanie GA eventov podla title
    communication.dataTrackModule.setScreenPath(2, $(e.target).find('.provider-content').first().find(".league-name").text()); // zaroven potrebujem zmenit aj tuto uroven cesty, lebo sa otvara automaticky
    return false;
});

// Odchytenie zbalenia DRUHEJ urovne VG PROVIDER
$("#sportsBookVG .SB-level-a").live("collapse", function () {
    communication.dataTrackModule.setScreenPath(1, ""); // GA4 - zaznamenanie cesty pre zmenu title pre trackovanie GA eventov podla title
    return false;
});

// Odchytenie TRETEJ urovne VG PROVIDER
$("#sportsBookVG .SB-level-a .ui-collapsible-content .league-name").live("mousedown", function (e) {
    communication.dataTrackModule.setScreenPath(2, $(e.target).text()); // GA4 - zaznamenanie cesty pre zmenu title pre trackovanie GA eventov podla title
});
